import {create, load_one} from '@/store/action-helpers'

export default {

    create: create('order-confirmation-requests'),
    loadOne: load_one('order-confirmation-requests/:id'),

}
